import { createTypes } from "./createTypes";

export default createTypes("ANSWER_CUSTOM_CLUE");
